<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight" style="overflow-y: auto;">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              Detalles del pago
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <v-container fluid v-if="paymentDetail">
          <v-col cols="12">
            <v-row>
              <v-col cols="1" sm="2"></v-col>
              <v-col cols="10" sm="8" class="px-0 px-sm-1">
                <v-row>
                  <v-col
                    cols="12"
                    v-if="settings.company"
                    class="primary-text-color font-16 pt-0"
                    ><b>
                      {{ settings.company.name }} -
                      {{ settings.company.company }}
                    </b></v-col
                  >
                  <v-col
                    cols="12"
                    v-if="settings.company"
                    class="primary-text-color font-16 pt-0 pb-0"
                  >
                    {{ settings.company.address }}
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="settings.company"
                    class="primary-text-color font-16 pt-0 pb-0"
                  >
                    {{ settings.company.nif }}
                  </v-col>

                  <v-col cols="12" class="primary-text-color font-16 "
                    ><b> Datos del cliente:</b></v-col
                  >

                  <v-col cols="12" class="primary-text-color font-16 pt-0 pb-0">
                    {{ paymentDetail.email }}
                  </v-col>
                  <v-col
                    cols="12"
                    class="primary-text-color font-16 pt-0 pb-0"
                    v-if="paymentDetail.invoiceRequest && paymentDetail.company"
                  >
                    {{ paymentDetail.company.name }}
                  </v-col>
                  <v-col
                    cols="12"
                    class="primary-text-color font-16 pt-0 pb-0"
                    v-if="paymentDetail.invoiceRequest && paymentDetail.company"
                  >
                    {{ paymentDetail.company.city }}
                  </v-col>
                  <v-col
                    cols="12"
                    class="primary-text-color font-16 pt-0 pb-0"
                    v-if="paymentDetail.invoiceRequest && paymentDetail.company"
                  >
                    {{ paymentDetail.company.address }}
                  </v-col>
                  <v-col
                    cols="12"
                    class="primary-text-color font-16 pt-0 pb-0"
                    v-if="
                      paymentDetail.invoiceRequest &&
                        paymentDetail.company &&
                        paymentDetail.company.postal_code
                    "
                  >
                    Código Postal.
                    <b>{{ paymentDetail.company.postal_code }}</b>
                  </v-col>
                  <v-col
                    cols="12"
                    class="primary-text-color font-16 pt-0 pb-0"
                    v-if="
                      paymentDetail.invoiceRequest &&
                        paymentDetail.company &&
                        paymentDetail.company.nif
                    "
                  >
                    NIF. <b>{{ paymentDetail.company.nif }}</b></v-col
                  >
                  <v-col
                    cols="12"
                    class="primary-text-color font-16 pt-0 pb-0"
                    v-if="
                      paymentDetail.invoiceRequest && paymentDetail.legal_number
                    "
                  >
                    INV. <b>{{ paymentDetail.legal_number }}</b></v-col
                  >
                </v-row>

                <section>
                  <table class="table" style="padding-top:12px">
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0; color: ${color};"
                    >
                      <th
                        style="padding: 0 15px 0 0;"
                        class="primary-text-color"
                      >
                        No.
                        {{ paymentDetail.number }}
                      </th>
                      <th
                        style="padding: 0 0 0 15px; text-align: end;"
                        class="primary-text-color"
                      ></th>
                    </tr>
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0; color: ${color};"
                    >
                      <th
                        style="padding: 0 15px 0 0;"
                        class="primary-text-color"
                      >
                        Mesa
                        {{ paymentDetail.tableQR }}
                      </th>
                      <th
                        style="padding: 0 0 0 15px; text-align: end;"
                        class="primary-text-color"
                      >
                        {{ formatDate(paymentDetail.payment_on) }}
                        {{ formatTime(paymentDetail.payment_on) }}
                      </th>
                    </tr>
                  </table>

                  <div class="divider height-5 primary-bg"></div>
                </section>

                <section>
                  <table
                    class="table"
                    v-if="paymentDetail.orders && paymentDetail.orders.length"
                  >
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0;"
                    >
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px 0 0;"
                      >
                        Producto
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px; text-align: center;"
                      >
                        Cantidad
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 0 0 15px; text-align: end;"
                      >
                        Precio
                      </th>
                    </tr>
                    <tr
                      v-for="(order, index) in paymentDetail.orders"
                      :key="index"
                    >
                      <td style="padding: 0 15px 0 0; width: 60%;">
                        {{ order.name }}
                      </td>
                      <td style="padding: 0 15px; text-align: center;">
                        {{ order.quantity }}
                      </td>
                      <td style="padding: 0 0 0 15px; text-align: end;">
                        <span v-if="order.isMenuGroupProduct">
                          {{
                            (
                              order.price * order.quantity +
                              totalWithAdditionalCharge(order)
                            ).toFixed(2)
                          }}
                          €
                        </span>
                        <span v-else>
                          {{ (order.price * order.quantity).toFixed(2) }} €
                        </span>
                      </td>
                    </tr>
                  </table>

                  <div
                    class="divider primary-bg"
                    v-if="
                      paymentDetail.orders &&
                        paymentDetail.orders.length &&
                        isInvitation()
                    "
                  ></div>
                  <table
                    class="table"
                    v-if="
                      paymentDetail.orders &&
                        paymentDetail.orders.length &&
                        isInvitation()
                    "
                  >
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0;"
                    >
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px 0 0;"
                      >
                        Invitación
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px; text-align: center;"
                      >
                        Cantidad
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 0 0 15px; text-align: end;"
                      >
                        Precio
                      </th>
                    </tr>
                    <tr
                      v-for="(order, index) in paymentDetail.orders"
                      :key="index"
                    >
                      <template v-if="order.selectOption === 'invitation'">
                        <td style="padding: 0 15px 0 0; width: 60%;">
                          {{ order.name }}
                        </td>
                        <td style="padding: 0 15px; text-align: center;">
                          {{ order.removeQuantity }}
                        </td>
                        <td style="padding: 0 0 0 15px; text-align: end;">
                          -
                          {{
                            (
                              order.price * order.removeQuantity +
                              totalWithAdditionalCharge(order)
                            ).toFixed(2)
                          }}
                          €
                        </td>
                      </template>
                    </tr>
                  </table>

                  <div class="divider primary-bg"></div>
                  <table class="table">
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0;"
                    >
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px 0 0;font-size: 20px;"
                      >
                        <b>Total de la cuenta </b>
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 0 0 15px; text-align: end;font-size: 20px;"
                      >
                        {{
                          paymentDetail.total_amount_order
                            ? parseFloat(
                                Number(paymentDetail.total_amount_order)
                              ).toFixed(2)
                            : (
                                this.total - this.getInvitationTotalPrice
                              ).toFixed(2)
                        }}
                        €
                      </th>
                    </tr>
                  </table>

                  <div class="divider primary-bg"></div>

                  <table class="table">
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0;"
                    >
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px 0 0;font-size: 20px;"
                      >
                        <b> Total Pagado </b>
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 0 0 15px; text-align: end;font-size: 20px;"
                      >
                        {{
                          paymentDetail.amount_paid_by_user
                            ? parseFloat(
                                Number(paymentDetail.amount_paid_by_user)
                              ).toFixed(2)
                            : parseFloat(this.total).toFixed(2)
                        }}
                        €
                      </th>
                    </tr>
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0;"
                    >
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px 0 0;"
                      >
                        Falta por pagar
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 0 0 15px; text-align: end;"
                      >
                        {{ parseFloat(remainingAmountToPay).toFixed(2) }} €
                      </th>
                    </tr>
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0;"
                    >
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px 0 0;"
                      >
                        Base imponible
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 0 0 15px; text-align: end;"
                      >
                        {{ getTaxBase(paymentDetail.amount_paid_by_user) }} €
                      </th>
                    </tr>
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0;"
                    >
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px 0 0;"
                      >
                        10% IVA
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 0 0 15px; text-align: end;"
                      >
                        {{ getIVA(paymentDetail.amount_paid_by_user) }} €
                      </th>
                    </tr>
                    <tr
                      style="border-bottom:1px solid #ecedee;text-align:left;padding:15px 0;"
                    >
                      <th
                        class="primary-text-color"
                        style="padding: 0 15px 0 0;"
                      >
                        Forma de pago
                      </th>
                      <th
                        class="primary-text-color"
                        style="padding: 0 0 0 15px; text-align: end;"
                      >
                        {{ displayPaymentMethod(paymentDetail.payment_method) }}
                      </th>
                    </tr>
                  </table>
                </section>
              </v-col>
              <v-col cols="1" sm="2"></v-col>
            </v-row>
          </v-col>
          <v-row>
            <v-col align="center">
              <div class="my-2 mr-5">
                <button
                  type="button"
                  class="active"
                  @click="printTicket(paymentDetail)"
                  style="background: rgb(0, 0, 0); border-color: rgb(138, 103, 73); color: rgb(255, 255, 255);height:35px;width:110px;"
                >
                  IMPRIMIR
                </button>
                <button
                  v-if="paymentDetail"
                  type="button"
                  class="active ml-2"
                  @click="editTicket(paymentDetail)"
                  style="background: rgb(0, 0, 0); border-color: rgb(138, 103, 73); color: rgb(255, 255, 255);height:35px;width:110px;"
                >
                  EDITAR
                </button>
                <button
                  type="button"
                  class="active ml-2"
                  @click="sendTicket(paymentDetail)"
                  style="background: rgb(0, 0, 0); border-color: rgb(138, 103, 73); color: rgb(255, 255, 255);height:35px;width:110px;"
                >
                  ENVIAR
                </button>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
      </div>
    </v-dialog>
    <edit-invoice-dialog
      ref="editInvoiceDialogRef"
      @editDetails="editedInvoiceDetails"
    ></edit-invoice-dialog>
    <send-invoice ref="sendInvoiceRef"></send-invoice>
  </div>
</template>

<script>
import {
  getPaymentById,
  paymentsCollection,
  updatePayment
} from "@/collections/payments";
import { printersCollection } from "@/collections/printers";
import Loader from "../../common/Loader";
import printerMixin from "@/mixins/printer/printerMixin";
import EditInvoiceDialog from "./EditInvoiceDialog.vue";
import SendInvoice from "./SendInvoice.vue";
import moment from "moment";
import { ordersCollection } from "@/collections/orders";
export default {
  name: "PaymentView",
  mixins: [printerMixin],
  props: ["ticketPrinter"],
  components: { Loader, EditInvoiceDialog, SendInvoice },
  data: () => ({
    dialog: false,
    paymentDetail: null,
    paymentsCollection: [],
    dialogLoader: false,
    printers: [],
    ordersCollection: []
  }),
  firestore() {
    return {
      paymentsCollection: paymentsCollection,
      printers: printersCollection.where("active", "==", true),
      ordersCollection: ordersCollection
    };
  },
  computed: {
    total() {
      let total = 0;
      if (
        this.paymentDetail &&
        this.paymentDetail.orders &&
        this.paymentDetail.orders.length > 0
      ) {
        this.paymentDetail.orders.forEach(item => {
          if (item.isMenuGroupProduct) {
            item.starters.forEach(starter => {
              total += parseFloat(starter.additional_charge) * item.quantity;
            });
            item.maincourse.forEach(main => {
              total += parseFloat(main.additional_charge) * item.quantity;
            });
            item.desserts.forEach(dessert => {
              total += parseFloat(dessert.additional_charge) * item.quantity;
            });
            item.drinks.forEach(drink => {
              total += parseFloat(drink.additional_charge) * item.quantity;
            });
          }
          total += item.quantity * item.price;
        });
      }
      return total;
    },
    getInvitationTotalPrice() {
      let total = 0;
      if (
        this.paymentDetail &&
        this.paymentDetail.orders &&
        this.paymentDetail.orders.length > 0
      ) {
        this.paymentDetail.orders.forEach(item => {
          if (item.selectOption === "invitation") {
            total +=
              item.removeQuantity * item.price +
              this.totalWithAdditionalCharge(item);
          }
        });
      }
      return total;
    },
    remainingAmountToPay() {
      const totalAmount = this.paymentDetail.total_amount_order
        ? parseFloat(Number(this.paymentDetail.total_amount_order)).toFixed(2)
        : (this.total - this.getInvitationTotalPrice).toFixed(2);
      const amoutPaid = this.paymentDetail.amount_paid_by_user
        ? parseFloat(Number(this.paymentDetail.amount_paid_by_user)).toFixed(2)
        : parseFloat(this.total).toFixed(2);
      return (parseFloat(totalAmount) - parseFloat(amoutPaid)).toFixed(2);
    }
  },
  methods: {
    async editedInvoiceDetails(paymentDetail) {
      try {
        this.paymentDetail = paymentDetail;
        this.paymentDetail.updated_on = moment().format();
        await updatePayment(paymentDetail.id, paymentDetail);
      } catch (error) {
        this.setlogError(
          "update_payment",
          "Obtained error message in editedInvoiceDetails()",
          error.stack,
          this.$options.name
        );
      }
    },
    displayPaymentMethod(payment_method) {
      if (payment_method === "credit_card") {
        return "Tarjeta de crédito";
      }

      if (payment_method === "cash") {
        return "Efectivo";
      }

      if (payment_method === "applepay") {
        return "Apple Pay";
      }

      if (payment_method === "datafono") {
        return "Tarjeta de crédito (Datáfono)";
      }

      if (payment_method === "googlepay") {
        return "Google Pay";
      }

      if (payment_method === "bizum") {
        return "Bizum";
      }
    },
    isInvitation() {
      return this.paymentDetail.orders.some(
        item => item.selectOption === "invitation"
      );
    },
    open(data) {
      let self = this;
      this.paymentDetail = null;
      this.dialogLoader = true;

      getPaymentById(data.id)
        .then(payment => {
          self.paymentDetail = payment;
          self.paymentDetail.id = data.id;
          // eslint-disable-next-line
          console.log(self.paymentDetail);
          this.dialogLoader = false;
        })
        .catch(error => {
          // eslint-disable-next-line
          this.setlogError(
            "get_payment_by_id",
            "Obtained error message in open()",
            error.stack,
            this.$options.name
          );
          this.dialogLoader = false;
        });

      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    printTicket(ordersGroup) {
      console.log("ordersGroup", ordersGroup);
      if (!this.printersAreActive) {
        this.showErrorMessage("Las impresoras no estan activas");
        return;
      }

      if (Object.keys(this.ticketPrinter).length === 0) {
        this.showErrorMessage("No has seleccionado todas las impresoras!");
        return;
      }

      const url = `${this.ticketPrinter.url}&id=${ordersGroup.tableQR}`;
      console.log("url", url);
      let array = [];
      let comments = [];

      ordersGroup.orders.forEach(item => {
        if (item.menu_group_id) {
          array.push({
            id: item.id,
            quantity: item.quantity,
            concept: item.order || item.name,
            price: item.price * item.quantity,
            size: item.size,
            notes: item.notes,
            canBeMainCourse: item.canBeMainCourse || false,
            canBeShared: item.canBeShared || false
            // big: this.isBig(item, printer)
          });
        } else {
          array.push({
            id: item.id,
            quantity: item.quantity,
            concept: item.order || item.name,
            price: item.price * item.quantity,
            size: item.size,
            notes: item.notes,
            canBeMainCourse: item.canBeMainCourse || false,
            canBeShared: item.canBeShared || false
            // big: this.isBig(item, printer)
          });
        }
      });
      const data = this.buildPrinterData(
        array,
        ordersGroup.tableQR,
        comments,
        ordersGroup.orders
      );
      data.isainvoice = true;
      data.tax = this.getTaxBase(ordersGroup.amount_paid_by_user);
      data.vat = this.getIVA(ordersGroup.amount_paid_by_user);
      data.time =
        this.formatDate(this.paymentDetail.payment_on) +
        " " +
        this.formatTime(this.paymentDetail.payment_on);
      data.amount_paid_by_user = parseFloat(
        Number(ordersGroup.amount_paid_by_user)
      );
      data.payment_method = ordersGroup.payment_method;
      data.total_amount_order = this.remainingAmountToPay;
      data.customer = { ...ordersGroup.company };
      data.company = {
        name:
          this.settings && this.settings.company
            ? this.settings.company.name
            : "",
        nif:
          this.settings && this.settings.company
            ? this.settings.company.nif
            : "",
        address:
          this.settings && this.settings.company
            ? this.settings.company.address
            : ""
      };
      data.legal_number =
        ordersGroup.invoiceRequest === true
          ? ordersGroup.legal_number
          : ordersGroup.number;
      console.log("data", data);
      let printerName = "";
      if (this.ticketPrinter.name) {
        printerName = this.ticketPrinter.name;
      }
      console.log("printerName", printerName);
      this.postPrinterRequest(url, data, printerName, "");
    },
    editTicket() {
      this.$refs.editInvoiceDialogRef.open(this.paymentDetail);
    },
    sendTicket() {
      this.paymentDetail.total_amount_order =
        this.total - this.getInvitationTotalPrice;
      this.$refs.sendInvoiceRef.open(this.paymentDetail);
    }
  }
};
</script>
<style scoped lang="scss">
.table {
  width: 100%;
}

.table th {
  font-size: 16px;
}

.table td {
  font-size: 14px;
}

.divider {
  height: 2px;
  width: 100%;
  display: block;
  margin: 15px 0;
}

.divider.height-5 {
  height: 5px !important;
}

.font-16 {
  font-size: 16px;
}

.font-20 {
  font-size: 20px;
}
</style>
